import { api, endpoints } from "api/api";
import { AxiosPromise, AxiosResponse } from "axios";

const fetch = (): AxiosPromise<LogFileApi[]> => {
  return api.get<LogFileApi[]>(endpoints.LOGS.GET_FILES());
};

const download = (fileName: string): AxiosPromise<AxiosResponse<Blob>> => {
  return api.get(endpoints.LOGS.GET_FILE(fileName), {
    responseType: "blob",
  });
};

export const logsApi = {
  fetch,
  download,
};

export interface LogFileApi {
  name: string;
  size: number;
}
